import axios from 'axios';
import appConfig from '@/utils/config';
import store from '@/store';
import isTokenValid from '@/utils/token';
import responseHandleError from '@/api/res-handle-error';

const axiosInstance = axios.create({
  baseURL: `${appConfig.API_BASE_URL}/`,
  withCredentials: true,
});

// Inctance without interceptors
axiosInstance.$token = axios.create({
  baseURL: `${appConfig.API_BASE_URL}/`,
});

const jwtacc = localStorage.getItem('jwtacc');
const locale = localStorage.getItem('locale');

if (jwtacc) {
  axiosInstance.defaults.headers.jwtacc = jwtacc;
}
if (locale) {
  axiosInstance.defaults.headers['x-user-locale'] = locale;
}

const handleStorageChange = (event) => {
  if (event.key === 'jwtacc') {
    if (event.newValue === null) {
      delete axiosInstance.defaults.headers.jwtacc;
    } else {
      axiosInstance.defaults.headers.jwtacc = event.newValue;
    }
  }
};

window.onstorage = handleStorageChange;

axiosInstance.interceptors.request.use(
  (config) => {
    if (axiosInstance.defaults.headers.jwtacc
       && !isTokenValid(axiosInstance.defaults.headers.jwtacc)) {
      axiosInstance.$app.$log.debug('Token expired in interceptor before call');
      const error = new Error('Token Expired');

      error.config = config;
      error.response = { status: 401 };
      error.status = error.response.status;
      throw error;
    }

    return config;
  },

  (error) => {
    axiosInstance.$app.$toast(error.message, {
      title: axiosInstance.$app.$t('toast.dunger'),
      variant: 'danger',
      solid: true,
      autoHideDelay: 15000,
    });
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => (response),
  async (error) => (responseHandleError(error, axiosInstance.$app, store)),
);

axiosInstance.mockApiError = () => {
  // API errors catched here. If custom handler is not requried

  // !error.response -> network error - hide error
  // error.response && error.response.statusCode === 401 -> auth error -> hide error
};

export default axiosInstance;
